/**Import react section */
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import propTypes from 'prop-types'
import withImmutablePropsToJS from 'with-immutable-props-to-js'
import { useHistory } from 'react-router-dom'

/**Import Material Ui section */
import { Typography, Paper, Button } from '@material-ui/core'

/**Import actions section */
import { updatePossibleService } from '../../../../store/services/serviceActions'
import { toSafeObject } from '../../../../store/helpers/StateHelper'

/**Import components section */
import ServiceHeaderForm from './ServiceHeaderForm'
import { getOptionsReactSelect } from '../../../../store/helpers/FilterHelper'
import { PositionMapDefault } from '../../../../store/helpers/AppConstants'

/**Import helpers section */
import { getUsersByRole } from '../../../../store/helpers/UserHelper'
import { DISPATCHER } from '../../../../resources/RolesEnum'

/**
 * Third step - Create Service
 */
const CreateServiceStep = (props) => {
	const dispatch = useDispatch()
	let history = useHistory()

	//objects props section
	const { service } = props

	const salesRepresentatives = useSelector((state) => toSafeObject(state.salesRepresentatives.get('salesRepresentatives')))
	const retails = useSelector((state) => toSafeObject(state.retails.get('retails')))
	const isSavingService = useSelector((state) => state.services.get('isSavingService'))
	const internalUsers = useSelector((state) => toSafeObject(state.users.get('internalUsers')))

	const [serviceModel, setServiceModel] = useState({
		Address: {}
	})
	const [mapPositionModel, setPositionModel] = useState({
		latitude: PositionMapDefault.latitude,
		longitude: PositionMapDefault.longitude
	})
	const [retailAddressModel, setRetailsAddressModel] = useState([])
	const [toasterOptions, setToasterOptions] = useState({
		open: false,
		variant: null,
		message: null
	})

	let representativesOptions = getOptionsReactSelect(salesRepresentatives)
	let retailsOptions = getOptionsReactSelect(retails)
	let emailsRolesDispatcher = getUsersByRole(DISPATCHER, internalUsers)

	/**On change properties for the service */
	const onPropertyChange = (event) => {
		let { name, value } = event.target
		setServiceModel({
			...serviceModel,
			[name]: value
		})
	}

	/** Invoke when select property change*/
	const onSelectChange = (name, valueProperty) => {
		setServiceModel({
			...serviceModel,
			[name]: valueProperty
		})
		if (name === 'Retailer') {
			setRetailsAddressModel(valueProperty.address || [])
		}
	}

	/**
	 * Action on Change address
	 * @param {*} address
	 */
	const onChangeAddress = (address) => {
		setServiceModel({
			...serviceModel,
			Address: address
		})
	}

	const redirectToService = (token) => {
		history.push(`/services/${token}/${'-'}`)
	}

	const redirectToHomeCancelService = () => {
		history.push(`/`)
	}

	/**
	 * Function add map position
	 * @param {*} position
	 */
	const onChangePosition = (position) => {
		setPositionModel({ latitude: position.lat, longitude: position.lng })
	}

	/**Create service in the back end */
	const addServiceOnClick = () => {
		dispatch(
			updatePossibleService(
				service.Token,
				serviceModel,
				mapPositionModel,
				props.userProfile ? props.userProfile.Account.Code : '',
				emailsRolesDispatcher
			)
		)
			.then(() => {
				redirectToService(service.Token)
			})
			.catch((error) => {
				setToasterOptions({ open: true, message: 'An error was generated while generating the request', variant: 'error' })
			})
	}

	return (
		<div>
			{/* Formulario de servicio */}
			{/* <div style={{ flex: 1, overflow: 'auto' }}> */}
			<ServiceHeaderForm
				onPropertyChange={onPropertyChange}
				representativesOptions={representativesOptions}
				retailsOptions={retailsOptions}
				isSavingService={isSavingService}
				serviceModel={serviceModel}
				onSelectChange={onSelectChange}
				position={mapPositionModel}
				onChangePosition={onChangePosition}
				onChangeAddress={onChangeAddress}
				retailDirections={retailAddressModel}
				redirectToHomeCancelService={redirectToHomeCancelService}
				addServiceOnClick={addServiceOnClick}
				userProfile={props.userProfile}
			/>
			{/* </div> */}

			{/* Barra de acciones
			<Paper
				style={{
					marginTop: '16px',
					padding: '16px',
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center'
				}}
			>
				<Button variant='outlined' color='primary' onClick={onBack} disabled={isSavingService}>
					Back
				</Button>

				<div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
					{isSavingService && <CircularProgress size={20} />}
					<Button variant='contained' color='primary' onClick={handleCreateService} disabled={isSavingService}>
						{isSavingService ? 'Creating Service...' : 'Create Service'}
					</Button>
				</div>
			</Paper> */}

			{/* Toaster para notificaciones */}
			{toasterOptions.open && (
				<Paper
					style={{
						position: 'fixed',
						bottom: '20px',
						right: '20px',
						padding: '16px',
						backgroundColor: toasterOptions.variant === 'error' ? '#f44336' : '#4caf50',
						color: 'white',
						zIndex: 9999
					}}
				>
					<Typography variant='body2'>{toasterOptions.message}</Typography>
					<Button size='small' style={{ color: 'white', float: 'right' }} onClick={() => setToasterOptions({ open: false })}>
						Cerrar
					</Button>
				</Paper>
			)}
		</div>
	)
}

CreateServiceStep.propTypes = {
	serie: propTypes.object,
	checklistData: propTypes.object,
	onSave: propTypes.func,
	onBack: propTypes.func,
	onComplete: propTypes.func,
	userProfile: propTypes.object
}

CreateServiceStep.defaultProps = {
	onSave: () => console.warn('Callback [onSave] no defined'),
	onBack: () => console.warn('Callback [onBack] no defined'),
	onComplete: () => console.warn('Callback [onComplete] no defined')
}

export default withImmutablePropsToJS(CreateServiceStep)
